import { atom } from "recoil";

export type PCSideTabType = "home" | "chat" | "mypage";
export const pcSideTabAtom = atom<PCSideTabType>({
  key: "pcSideTab",
  default: "home",
});